module.exports = __webpack_public_path__ + "static/media/45.5b05e173.png";